import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { StyledNoMenuOptions } from './styled';
import { scrollToFocusedOption } from '../../utils';
import { isArrayWithLength, formatClassNames } from '../../../../helpers';

const Menu = ({ menuOptions, focusedOptionKey, formatOptionLabel, setFocusedOptionRef, focusedOptionRef, menuRef, noOptionsMessage }) => {
  useEffect(() => {
    if (focusedOptionRef && menuRef.current) {
      scrollToFocusedOption(menuRef.current, focusedOptionRef);
    }
  }, [focusedOptionRef]);

  if (!isArrayWithLength(menuOptions)) {
    return (
      <StyledNoMenuOptions>{noOptionsMessage}</StyledNoMenuOptions>
    );
  }

  return (
    menuOptions.map((option, index) => {
      const classes = formatClassNames(['option', (option.value === focusedOptionKey) && 'focused',
        option.isSelected && 'selected', option.fixed && 'fixed']);

      return (
        <div 
          key={option.key}
          id={`option-${index}`} 
          {...option.innerProps}
          ref={(option.value === focusedOptionKey) ? setFocusedOptionRef : undefined}
          className={classes}
        >
          {formatOptionLabel(option.data)}
        </div>
      );
    })
  );
};

Menu.propTypes = {
  menuOptions: PropTypes.array,
  focusedOptionKey: PropTypes.any,
  setFocusedOptionRef: PropTypes.func,
  noOptionsMessage:  PropTypes.string,
  formatOptionLabel: PropTypes.func.isRequired,
  menuRef: PropTypes.oneOfType([
    PropTypes.func, 
    PropTypes.shape({ current: PropTypes.instanceOf(Element) })
  ]),
  focusedOptionRef: PropTypes.oneOfType([
    PropTypes.func, 
    PropTypes.shape({ current: PropTypes.instanceOf(Element) })
  ]),
};

export default Menu;